import { Checkbox } from '@/components/inputs';
import { BaseDestinationItem } from '@/features/destinations/commons';
import { DestinationConnectionToggle } from '@/features/destinations/commons/DestinationConnectionToggle';
import { DistributionChannelConnector } from '@/models/distributionChannels';
import { FC } from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateCampaignFormInput } from '../../../../validation';

type DestinationItemProps = {
  connector: DistributionChannelConnector;
  selectedDisconnectedConnector: DistributionChannelConnector | null;
  onSelectedDisconnectedConnector: (connector: DistributionChannelConnector | null) => void;
};

export const DestinationItem: FC<DestinationItemProps> = ({ connector, selectedDisconnectedConnector, onSelectedDisconnectedConnector }) => {
  const { t } = useTranslation(['ALL', 'COMMON']);

  const { installed, authenticated } = connector;

  const isConfigured = installed && authenticated;

  const { control } = useFormContext<CreateCampaignFormInput>();
  const { append: addConnector, remove: removeConnector } = useFieldArray({
    control,
    name: 'connectors',
  });

  const dataDestinationsSelected = useWatch({
    control,
    name: 'connectors',
  });
  const isDestiantionSelected = !!dataDestinationsSelected.find((c) => c.connector.accountConnectorId === connector.accountConnectorId);

  const handleConnectorSelected = ($event) => {
    const { checked } = $event.target;

    if (checked) {
      addConnector({
        connector,
      });
    } else {
      const indexConnector = dataDestinationsSelected.findIndex((c) => c.connector.accountConnectorId === connector.accountConnectorId);
      removeConnector(indexConnector);
    }
  };

  return (
    <BaseDestinationItem connector={connector}>
      {isConfigured && (
        <Checkbox
          label={t('COMMON:select')}
          wrapperClassName='my-0 mb-3 pb-3 border-b'
          labelWrapperClassName='capitalize text-sm text-black-100'
          inputWrapperClassName='items-end'
          checked={isDestiantionSelected}
          onChange={handleConnectorSelected}
        />
      )}
      <DestinationConnectionToggle
        deauthenticateDisabled={!!selectedDisconnectedConnector || isConfigured}
        onChangeConnectionInProgress={onSelectedDisconnectedConnector}
        connector={connector}
      />
    </BaseDestinationItem>
  );
};
